<template>
  <div class="widget-card widget-sales">
    <v-card class="widget-card__card" height="100%">
      <v-card-title class="primary white--text widget-card__card-title">Задания</v-card-title>

      <v-card-text class="widget-card__card-text pt-3">
        <div v-if="gamesList && !gamesList.length">Список акций пуст</div>
        <div v-else>
          <ul class="list">
            <li class="item" v-for="(a, idx) in gamesList" :key="idx">{{a.title}}</li>
          </ul>
        </div>
      </v-card-text>

      <v-card-actions class="pa-3 widget-card__card-actions widget-sales__actions" bottom>
        <v-btn block color="default" to="/games" class="mb-3 widget-card__actions-btn" v-if="isDealer && isPeriodOpen">
          <v-icon>mdi-checkbox-multiple-marked-circle-outline</v-icon>
          <span class="pl-4">Активных заданий: <b>{{ actualGamesCount }}</b></span>
        </v-btn>
        <v-banner  v-if="isDealer && !isPeriodOpen"> <span class="pl-4"></span></v-banner>
        <v-btn block color="default" to="/games" class="ml-0 widget-card__actions-btn">
          <v-icon>mdi-playlist-check</v-icon>
          <span class="pl-4">Мои задания</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['user', 'list'],
  computed: {
    isManager() { return this.$store.getters.isManager; },
    actualGamesCount() { return this.$store.state.game.actualGamesCount; },
    isDealer() { return this.$store.getters.isDealer; },
    isPeriodOpen() { return this.$store.getters.isPeriodOpen; },
    gamesList() { return this.$store.state.game.gamesList || []; },
  },
};
</script>

<style lang="scss">
.widget-sales {
  &__actions {
    flex-direction: column;
  }
  .list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .item {
    margin-bottom: 8px;
  }
}
</style>
